import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";
import { getNodeCustomerAccess } from "../../../utils/staffCustomerAccess";
import { getCpapFollowupAssignedNodes, getCpapFollowupRole, isCpapFollowupNodeCustomerScopedUser } from "./cpapFollowupAccess";

export const loadCpapFollowupScope = async (currentUser, allNodes, includeSale = true) => {
  const scoped = isCpapFollowupNodeCustomerScopedUser(currentUser);
  if (!scoped && !(includeSale && getCpapFollowupRole(currentUser) === "sale")) {
    return { nodes: allNodes, adminData: null };
  }
  if (!currentUser.displayName) return { nodes: [], adminData: null };
  const snapshot = await getDoc(doc(db, "admins", currentUser.displayName));
  const adminData = snapshot.exists() ? snapshot.data() : null;
  const assignedNodes = getCpapFollowupAssignedNodes(allNodes, adminData, currentUser);
  const nodes = await Promise.all(assignedNodes.map(async (node) => {
    if (!scoped || getNodeCustomerAccess(adminData, node.nodecode).mode !== "selected") return node;
    // Access assignments use document IDs, while older follow-ups may store
    // customer display names. Resolve names only inside their assigned node.
    const customers = await getDocs(collection(db, "nodes", node.id, "customers"));
    return { ...node, customers: customers.docs.map((row) => ({ ...row.data(), id: row.id })) };
  }));
  return { nodes, adminData };
};
